import { CharacterClass } from '../../shared/CharacterTypes';
import { WARRIOR_CONFIG } from './configs/WarriorConfig';
import { MAGE_CONFIG } from './configs/MageConfig';
import { HUNTER_CONFIG } from './configs/HunterConfig';
import { PALADIN_CONFIG } from './configs/PaladinConfig';
import { DEV_CONFIG } from './configs/DevClassConfig';
import { ROGUE_CONFIG } from './configs/RogueConfig';
import { SHAMAN_CONFIG } from './configs/ShamanConfig';
import { PRIEST_CONFIG } from './configs/PriestConfig';
import { WARLOCK_CONFIG } from './configs/WarlockConfig';
import { DRUID_CONFIG } from './configs/DruidConfig';

// Character class configurations
export const CLASS_CONFIGS = {
  [CharacterClass.WARRIOR]: WARRIOR_CONFIG,
  [CharacterClass.MAGE]: MAGE_CONFIG,
  [CharacterClass.HUNTER]: HUNTER_CONFIG,
  [CharacterClass.PALADIN]: PALADIN_CONFIG,
  [CharacterClass.DEV]: DEV_CONFIG,
  [CharacterClass.ROGUE]: ROGUE_CONFIG,
  [CharacterClass.SHAMAN]: SHAMAN_CONFIG,
  [CharacterClass.PRIEST]: PRIEST_CONFIG,
  [CharacterClass.WARLOCK]: WARLOCK_CONFIG,
  [CharacterClass.DRUID]: DRUID_CONFIG,
};
